import { GlobalFunctions } from "./global-functions";

export class Global extends GlobalFunctions {


}